<app-user-select-filter-standalone
    [multiple]="multiple"
    [parentFormGroup]="parentFormGroup"
    [parentFormControlName]="parentFormControlName"
    (userSelectedEvent)="userSelectedEvent.emit($event)"
    [users]="users"
    [loading]="service.loading$ | async">
</app-user-select-filter-standalone>
